export const FORMLY_FIELD_VALIDATORS = {
	duplicate: 'duplicate',
	email: 'email',
	maxDecimalPlaces: 'maxDecimalPlaces',
	requiredNoWhitespace: 'whitespace',
	hasBegEndWhitespace: 'hasBegEndWhitespace',
	lettersOnly: 'lettersOnly',
	mask: 'mask',
	duplicateAsync: 'duplicateAsync',
	match: 'match',
	notGreaterThanZero: 'notGreaterThanZero',
	minTime: 'minTime',
	maxTime: 'maxTime',
	timeRange: 'timeRange',
	phoneNumber: 'phoneNumber',
	routingNumber: 'routingNumber',
};
